import React from 'react';
import ProjectPageInfo from '../components/ProjectPageInfo/ProjectPageInfo';

const desktopImages = [
  {
    id: 1, name: 'Homepage', url: '/images/desktop/aston-martin/index-desktop-darkmap.jpg',
  },
  {
    id: 2, name: 'Model', url: '/images/desktop/aston-martin/model-desktop.jpg',
  },
  {
    id: 3, name: 'Showroom', url: '/images/desktop/aston-martin/showroom-desktop.jpg',
  },
  {
    id: 4, name: 'SRP', url: '/images/desktop/aston-martin/srp-desktop.jpg',
  },
  {
    id: 5, name: 'VDP', url: '/images/desktop/aston-martin/vdp-desktop.jpg',
  },
];

const mobileImages = [
  {
    id: 1, name: 'Homepage', url: '/images/mobile/aston-martin/index-mobile.jpg',
  },
  {
    id: 2, name: 'Model', url: '/images/mobile/aston-martin/model-mobile.jpg',
  },
  {
    id: 3, name: 'Showroom', url: '/images/mobile/aston-martin/showroom-mobile.jpg',
  },
  {
    id: 4, name: 'SRP', url: '/images/mobile/aston-martin/srp-mobile.jpg',
  },
  {
    id: 5, name: 'VDP', url: '/images/mobile/aston-martin/vdp-mobile.jpg',
  },
];

const Ogara = () => (
  <>
      <ProjectPageInfo
        title="Aston Martin"
        icon="bi bi-geo-fill"
        location="USA Retail Dealerships"
        liveUrl="https://www.astonmartinaustin.com/"
        desktopImages={desktopImages}
        mobileImages={mobileImages}
        backgroundColor="#021F1D"
        backgroundColorTwo="#003D35"
        heroImage="/images/project-page/aston-martin/aston-hero.png"
        imacIpad="/images/project-page/aston-martin/aston-imac-ipad.png"
        phoneOne="/images/project-page/aston-martin/aston-phone.png"
        phoneTwo="/images/project-page/aston-martin/aston-iphone-2.png"
      />
  </>
);

export default Ogara;

